import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Company, ContactReferrerArrangement } from '@features/contacts/models';

@Component({
  selector: 'spark-contacts-referrer-arrangement-summary',
  templateUrl: './summary-view.component.html'
})
export class ReferrerArrangementSummaryComponent {
  @Input() referrerArrangement!: ContactReferrerArrangement.Model;

  @Output() clicked = new EventEmitter();
  constructor() {}

  public cardClicked(): void {
    this.clicked.emit();
  }
}
